<template>
    <progress max="100" :value.prop="uploadPercentage"></progress>
</template>

<script>
    export default {
        props: ['uploadPercentage'],
    }
</script>